import { Model } from '../Model';
export class CurrentUserMfaAuthenticators extends Model {
    static from(data) {
        return new CurrentUserMfaAuthenticators(data);
    }
    get authenticators() {
        return this.data;
    }
    get getAuthenticatorByType() {
        return (type) => this.authenticators.find((authenticator) => authenticator.type === type);
    }
    get isEnrolled() {
        return this.authenticators.some((authenticator) => authenticator.enrolled);
    }
}
